module.exports = __webpack_public_path__ + "img/machinery.445011d1.svg";